import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
// @mui
import { Box, Modal, Button, Stack, TextField } from '@mui/material';
import { cores, AutoComplete, labelCampoEscuro } from '../styles/styleUtils';
import { getGenericData } from './api';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '50vw',
  height: '50vh',
  '@media screen and (max-width: 600px)': {
    width: '50vw', // Width de 100% para telas de celulares
    height: '50vh',
  },
  bgcolor: 'transparent',
  border: `1px solid ${cores.chumbo}`, borderTop: `4px solid ${cores.laranja}`,
  boxShadow: 24,
  p: 2,
  display: 'flex',
  flexDirection: 'column',
  overflowY: 'auto',
  background: `linear-gradient(180deg, ${cores.painelTopo} 0%, ${cores.painelBase} 100%)`,
  alignItems: 'center',
  justifyContent: 'center',
  gap: 2
};

// Subtipo = topologia do sistema (on-grid / off-grid). Grid-zero NÃO é subtipo:
// é tratado como motivo ("Usina Grid-Zero") sobre um sistema on-grid.
// Guardamos o nome igual ao do produto real para o dashboard poder somar depois.
const subtipos = ['Gerador On-Grid', 'Gerador Off-Grid'];

const motivos = ['Usina de Solo', 'Usina Grid-Zero', 'Inversor Maior Que Padrão', 'Painéis Avulsos', 'Inversor Avulso', 'Manutenção Em Usina Com Venda de Produto', ' Marca ou Modelo Específicos', 'Outros']
// ----------------------------------------------------------------------

// eslint-disable-next-line no-unused-vars
const ModalPropostaPersonalizada = React.forwardRef((props, ref) => {
  const [fornecedor, setFornecedor] = useState([]);
  useEffect(() => {
    const getFornecedores = async () => {
      const result = await getGenericData('fornecedor', {});
      result.push({_id:'999', nome: 'Outros'})
      setFornecedor(result);
    };
    getFornecedores();
  }, []);

  return (
    <Modal
      open={props.open}
      onClose={props.onClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <Box mb={5}>
          <strong style={{ color: cores.textoClaro }}>Informe o tipo de sistema e o motivo</strong>
        </Box>

        {/* Subtipo: que sistema é (on-grid / off-grid / grid-zero) */}
        <AutoComplete
          disablePortal
          id="subtipoPersonalizado"
          name="subtipoPersonalizado"
          value={props.proposta?.subtipoPersonalizado || null}
          onChange={(_, value) => props.onAutoCompleteChange('idSubtipoPersonalizado', 'subtipoPersonalizado', value)}
          options={subtipos}
          isOptionEqualToValue={(option, value) => option === value}
          getOptionLabel={(option) => `${option}`}
          renderInput={(params) => <TextField {...params} placeholder="Tipo de sistema" />}
          disabled={!props.onAutoCompleteChange}
        />

        <AutoComplete
          disablePortal
          id="motivoPersonalizado"
          name="motivoPersonalizado"
          value={props.proposta?.motivoPersonalizado || null}
          onChange={(_, value) => props.onAutoCompleteChange('idMotivoPersonalizado', 'motivoPersonalizado', value)}
          options={motivos}
          isOptionEqualToValue={(option, value) => option === value}
          getOptionLabel={(option) => `${option}`}
          renderInput={(params) => <TextField {...params} placeholder="Motivo" />}
          disabled={!props.onAutoCompleteChange}
        />

        <AutoComplete
          disablePortal
          id="fornecedorPersonalizado"
          name="fornecedorPersonalizado"
          value={props.proposta?.fornecedorPersonalizado || null}
          onChange={(_, value) => props.onAutoCompleteChange('idFornecedorPersonalizado', 'fornecedorPersonalizado', value)}
          options={fornecedor}
          isOptionEqualToValue={(option, value) => option._id === value._id}
          getOptionLabel={(option) => `${option.nome}`}
          renderInput={(params) => <TextField {...params} placeholder="Fornecedor" />}
          disabled={!props.onAutoCompleteChange}
        />

        <TextField
          id="obsPersonalizado"
          label="Informações Adicionais"
          variant="outlined"
          value={props.proposta?.obsPersonalizado || ''}
          multiline
          rows={4}
          onChange={(e) => props.onAutoCompleteChange('idObsPersonalizado', 'obsPersonalizado', e.target.value)}
          sx={{ width: '70%', backgroundColor: 'white', ...labelCampoEscuro, mt: 1 }}
          disabled={!props.onAutoCompleteChange}
        />
        <Stack direction={'row'} justifyContent={'space-between'} gap={20} mt={5}>
          <Button variant="outlined" onClick={props.onClose} color="error">
            {' '}
            Cancelar
          </Button>
          <Button variant="contained" disabled={!props.proposta?.subtipoPersonalizado || !props.proposta?.motivoPersonalizado || !props.onAutoCompleteChange} color="success" onClick={() => props.onConfirm()}>
            Confirmar
          </Button>
        </Stack>
      </Box>
    </Modal>
  );
});

ModalPropostaPersonalizada.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  onConfirm: PropTypes.func,
};

export default ModalPropostaPersonalizada;